import { t } from '@/lib/i18n';
import { useJobRecommendations } from '../hooks';
import styles from './PendingHireBanner.module.css';

interface PendingAddBannerProps {
  staffProfileId: string;
  templateId: string | null;
}

/**
 * Inline confirmation shown under the assignee picker when the user selected
 * a Staff Profile that isn't added yet. Reads from the same recommendations
 * cache as the picker — so the name comes for free without an extra request.
 */
export function PendingAddBanner({ staffProfileId, templateId }: PendingAddBannerProps) {
  const recs = useJobRecommendations(templateId);
  const profile = recs.data?.availableToAdd.find((p) => p.id === staffProfileId);
  const name = profile ? [profile.first_name, profile.last_name].filter(Boolean).join(' ') : '';
  if (!name) return null;
  return (
    <div className={styles.banner} role="status">
      <span className={styles.icon} aria-hidden>
        →
      </span>
      <span>{t('{name} will be added to your team when you Start this job.', { name })}</span>
    </div>
  );
}
